import { css } from '@emotion/react';
import { tokens, applyFont } from '@domain-group/fe-brary';

const { spacing, colors, typography, borderRadius } = tokens;

export const banner = css`
  display: flex;
  align-items: center;
  gap: ${spacing.s};
  padding: ${spacing.s} ${spacing.m};
  border-radius: ${borderRadius.outer};
  background-color: ${colors.neutral.subdued.default};
`;

export const icon = css`
  flex-shrink: 0;
  color: ${colors.neutral.medium.default};
`;

export const text = css`
  ${applyFont(typography.caption)}
  color: ${colors.neutral.medium.default};
  margin: 0;
  word-break: break-word;
`;
